import { ActivitiesInternalResource as e } from "./resources/ActivitiesInternalResource.js";
import { AgentConfigurationResource as t } from "./resources/agent-configuration/AgentConfigurationResource.js";
import { AnswerResource as n } from "./resources/answer/AnswerResource.js";
import { AutomationFreezesResource as r } from "./resources/AutomationFreezesResource.js";
import { BatchAnswerResource as i } from "./resources/batch-answer/BatchAnswerResource.js";
import { CaseAssistConfigsInternalResource as a } from "./resources/CaseAssistConfigstInternalResource.js";
import { ChunkInspectorResource as o } from "./resources/chunk-inspector/ChunkInspectorResource.js";
import { CommerceResource as s } from "./resources/commerce/Commerce.js";
import { ConversationInspectorResource as c } from "./resources/conversation-inspector/ConversationInspectorResource.js";
import { ConditionResource as l } from "./resources/ConditionResource.js";
import { CrawlingModuleInternalResource as u } from "./resources/CrawlingModuleInternalResource.js";
import { CRGADashboardResource as d } from "./resources/crga-dashboard/CRGADashboardResource.js";
import { DataServiceResource as f } from "./resources/DataServiceResource.js";
import { DocumentIdentityResource as p } from "./resources/DocumentIdentityResource.js";
import { ExportServiceResource as m } from "./resources/ExportServiceResource.js";
import { ExtensionInternalResource as h } from "./resources/ExtensionInternalResource.js";
import { HostedPagesInternalResource as g } from "./resources/HostedPagesInternalResource.js";
import { InAppWidgetResource as _ } from "./resources/InAppWidgetResource.js";
import { InsightPanelConfigsInternalResource as v } from "./resources/InsightPanelConfigsInternalResource.js";
import { IPXInterfaceExperimentalResource as y } from "./resources/IPXInterfaceResource.js";
import { LicenseInternalResource as b } from "./resources/LicenseInternalResource.js";
import { LogicalIndexesResource as x } from "./resources/LogicalIndexesResource.js";
import { MCPConfigurationsResource as S } from "./resources/MCPConfigurationsResource.js";
import { MCPPipelinesResource as C } from "./resources/MCPPipelinesResource.js";
import { ModelsInternalResource as w } from "./resources/ModelsInternalResource.js";
import { NextGenSearchPagesInternalResource as T } from "./resources/NextGenSearchPagesInternalResource.js";
import { NotificationEventResource as E } from "./resources/NotificationEventResource.js";
import { OrganizationCustomerKeysResource as D } from "./resources/OrganizationCustomerKeysResource.js";
import { OrganizationDefinitionResource as O } from "./resources/OrganizationDefinitionResource.js";
import { OrganizationHealthMonitoringResource as k } from "./resources/OrganizationHealthMonitoringResource.js";
import { OrganizationInternalResource as A } from "./resources/OrganizationInternalResource.js";
import { OrganizationMonitoringResource as j } from "./resources/OrganizationMonitoringResource.js";
import { OrganizationQuotasResource as M } from "./resources/OrganizationQuotasResource.js";
import { OrganizationSettingsResource as N } from "./resources/OrganizationSettingsResource.js";
import { PipelineInternalResource as P } from "./resources/PipelineInternalResource.js";
import { PipelineSettingsResource as F } from "./resources/PipelineSettingsResource.js";
import { PreviewResource as I } from "./resources/PreviewResource.js";
import { PrivateLicenseResource as L } from "./resources/PrivateLicenseResource.js";
import { PrivilegesResource as R } from "./resources/PrivilegesResource.js";
import { ProjectInternalResource as z } from "./resources/ProjectInternalResource.js";
import { ReportInternalResource as B } from "./resources/ReportInternalResource.js";
import { SalesforceSourceConfigurationInternalResource as V } from "./resources/SalesforceSourceConfigurationInternalResource.js";
import { SchemaServiceTemporaryResource as H } from "./resources/SchemaServiceTemporaryResource.js";
import { SearchDictionaryFieldsResource as U } from "./resources/SearchDictionaryFieldsResource.js";
import { SearchInterfacesInternalResource as W } from "./resources/SearchInterfacesInternalResource.js";
import { SearchPagesInternalResource as G } from "./resources/SearchPagesInternalResource.js";
import { SecurityCacheInternalResource as K } from "./resources/SecurityCacheInternalResource.js";
import { SourcesInternalResource as q } from "./resources/SourcesInternalResource.js";
import { CatalogsInternalResource as J } from "./resources/CatalogsInternalResource.js";
import { PlatformClient as Y } from "@coveo/platform-client";
//#region src/PrivatePlatformClient.ts
var X = [
	{
		key: "activitiesInternal",
		resource: e
	},
	{
		key: "agentConfiguration",
		resource: t
	},
	{
		key: "answer",
		resource: n
	},
	{
		key: "automationFreezes",
		resource: r
	},
	{
		key: "batchAnswer",
		resource: i
	},
	{
		key: "catalogsInternal",
		resource: J
	},
	{
		key: "caseAssistConfigsInternal",
		resource: a
	},
	{
		key: "chunkInspector",
		resource: o
	},
	{
		key: "commerce",
		resource: s
	},
	{
		key: "conversationInspector",
		resource: c
	},
	{
		key: "condition",
		resource: l
	},
	{
		key: "crawlingModuleInternal",
		resource: u
	},
	{
		key: "crgaDashboard",
		resource: d
	},
	{
		key: "dataService",
		resource: f
	},
	{
		key: "documentIdentity",
		resource: p
	},
	{
		key: "exportService",
		resource: m
	},
	{
		key: "extensionInternal",
		resource: h
	},
	{
		key: "inAppWidget",
		resource: _
	},
	{
		key: "insightPanelConfigsInternal",
		resource: v
	},
	{
		key: "hostedPagesInternal",
		resource: g
	},
	{
		key: "ipxInterfaceExperimental",
		resource: y
	},
	{
		key: "licenseInternal",
		resource: b
	},
	{
		key: "logicalIndexes",
		resource: x
	},
	{
		key: "mcpConfigurations",
		resource: S
	},
	{
		key: "mcpPipelines",
		resource: C
	},
	{
		key: "modelsInternal",
		resource: w
	},
	{
		key: "nextGenSearchPagesInternal",
		resource: T
	},
	{
		key: "notificationEvent",
		resource: E
	},
	{
		key: "organizationInternal",
		resource: A
	},
	{
		key: "organizationCustomerKeys",
		resource: D
	},
	{
		key: "organizationDefinition",
		resource: O
	},
	{
		key: "organizationQuotas",
		resource: M
	},
	{
		key: "organizationHealthMonitoring",
		resource: k
	},
	{
		key: "organizationMonitoring",
		resource: j
	},
	{
		key: "organizationSettings",
		resource: N
	},
	{
		key: "pipelineInternal",
		resource: P
	},
	{
		key: "pipelineSettings",
		resource: F
	},
	{
		key: "privateLicense",
		resource: L
	},
	{
		key: "preview",
		resource: I
	},
	{
		key: "privileges",
		resource: R
	},
	{
		key: "projectInternal",
		resource: z
	},
	{
		key: "reportInternalResource",
		resource: B
	},
	{
		key: "salesforceSourceConfigurationInternal",
		resource: V
	},
	{
		key: "schemaServiceTemporary",
		resource: H
	},
	{
		key: "searchDictionaryFields",
		resource: U
	},
	{
		key: "searchInterfacesInternal",
		resource: W
	},
	{
		key: "searchPagesInternal",
		resource: G
	},
	{
		key: "sourcesInternal",
		resource: q
	},
	{
		key: "securityCacheInternal",
		resource: K
	}
], Z = class extends Y {
	constructor(e) {
		super(e), X.forEach(({ key: e, resource: t }) => {
			this[e] = new t(this.API, this.ServerlessAPI);
		});
	}
};
//#endregion
export { Z as PrivatePlatformClient };

//# sourceMappingURL=PrivatePlatformClient.js.map